import { Link } from 'react-router-dom';
import type { SidebarMenuItem } from './sidebarTypes';

type SidebarItemProps = {
  item: SidebarMenuItem;
  active: boolean;
};

function SidebarItem({ item, active }: Readonly<SidebarItemProps>) {
  return (
    <Link className={`subnav-item${active ? ' active' : ''}`} to={item.path}>
      <span>{item.label}</span>
    </Link>
  );
}

export default SidebarItem;
